import { createContext } from "react";

const DiagnosticModalContext = createContext();

export default DiagnosticModalContext;
